// Canonical list of the 11 HTC chapters.
// Icons are picked from the lucide-react set to keep the institutional
// aesthetic (no emoji in the product UI per design guidelines), but we
// keep an `emoji` field as a fallback / lightweight marker used on home
// cards when a decorative touch is welcome.

export const CHAPTERS = [
  { id: 0,  emoji: "📖", title: "Bienvenue & Philosophie",              duration: 3,  durationLabel: "3 min" },
  { id: 1,  emoji: "🚀", title: "Premiers Pas",                         duration: 5,  durationLabel: "5 min" },
  { id: 2,  emoji: "📂", title: "Importer vos Documents PDF",           duration: 8,  durationLabel: "8 min" },
  { id: 3,  emoji: "👤", title: "Configurer le Profil Contribuable",    duration: 6,  durationLabel: "6 min" },
  { id: 4,  emoji: "⚗️", title: "Comprendre l'Analyse Vitaliste",        duration: 7,  durationLabel: "7 min" },
  { id: 5,  emoji: "📊", title: "Dashboard & Graphiques",               duration: 8,  durationLabel: "8 min" },
  { id: 6,  emoji: "⚖️", title: "Analyse Juridique",                     duration: 10, durationLabel: "10 min" },
  { id: 7,  emoji: "🏛️", title: "Simulation de Jugement",                duration: 8,  durationLabel: "8 min" },
  { id: 8,  emoji: "📄", title: "Générer & Télécharger les Rapports",   duration: 6,  durationLabel: "6 min" },
  { id: 9,  emoji: "🔬", title: "Fonctionnalités Avancées",             duration: 9,  durationLabel: "9 min" },
  { id: 10, emoji: "❓", title: "FAQ & Dépannage",                       duration: 5,  durationLabel: "5 min" },
  { id: 11, emoji: "⚫", title: "DEBT-VITA™ : La Dette en Vies",          duration: 10, durationLabel: "10 min" },
];

export const CHAPTER_BY_ID = Object.fromEntries(
  CHAPTERS.map((c) => [String(c.id), c])
);

export function getChapterById(id) {
  return CHAPTER_BY_ID[String(id)] || null;
}
